import { EventDto, ReservationRequestDto } from "@/api/generated/generatedTypes";

export interface ChangeRequestModalProps {
  opened: boolean;
  onClose: () => void;
  reservation: ReservationRequestDto;
  currentEvent: EventDto;
  availableEvents: EventDto[];
}

export interface CurrentReservationDisplayProps {
  request: ReservationRequestDto;
  currentEventTime: string;
  currentEventLocation: string;
}

export interface EventSelectionListProps {
  events: EventDto[];
  selectedEventId: number | null;
  onSelectEvent: (eventId: number) => void;
}

export const formatTime = (time: Date | string): string => {
  const timeString = typeof time === "string" ? time : time.toISOString();
  return new Date(timeString).toLocaleString();
};
